import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ExportView from '../views/ExportView.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/verktyg/export',
    name: 'optimizely export',
    component: ExportView
  },
  
  {
    path: '/export',
    name: 'export',
    component: ExportView
  },
  {
    path: '/verktyg/id/:id',
    name: 'optimizely url id',
    component: HomeView
  },
  {
    path: '/verktyg/:chapters*',
    name: 'optimizely dynamic',
    component: HomeView
  },
  {
    path: '/id/:id',
    name: 'url id',
    component: HomeView
  },
  {
    path: '/:chapters*',
    name: 'dynamic',
    component: HomeView
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
